export const COMPONENT_DOCUMENT_TYPE = 'elementor_component';
